import React from 'react'

import {
  $DCprimaryColor,
  DcButton,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'
import styled from 'styled-components'
import { get, post } from 'utils/api-routes.util'
import PlusIcon from 'utils/icons/plus-icon'
import { IPixelFactory } from '../../../../../../decl.d'

const SMSPlans = ({ getAllSmsConfig, remainingCredits }) => {
  const { showLoader, hideLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)
  const [allPlans, setAllPlans] = React.useState([])
  const readData = () => {
    showLoader(mainSectionRef)
    get('/communication/plans').subscribe((res: any) => {
      setAllPlans(res.response.data)
      hideLoader(mainSectionRef)
    })
  }
  const handleBuy = (id: number) => {
    showLoader(mainSectionRef)
    post('/communication/plans', {
      plan_id: id,
    }).subscribe((res: any) => {
      if (res.response.data) {
        getAllSmsConfig()
        hideLoader(mainSectionRef)
        readData()
        showSuccess('Successfully subscribed to the plan')
      } else {
        hideLoader(mainSectionRef)
        showFailure(res.response.error)
      }
    })
  }

  React.useEffect(() => {
    readData()
  }, [])
  return (
    <>
      <PixelFlexBox
        justifyContent="center"
        gap="40px"
        backgroundColor="#f9f9f9"
        margin="15px 0 0 0"
        style={{
          borderRadius: '12px',
        }}
        className="table-info"
        ref={mainSectionRef}
      >
        {allPlans.map((plan: any, i) => {
          return (
            <PixelFlexBox
              flexDirection="column"
              padding="10px 15px"
              style={{
                borderRadius: '12px',
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                background: plan.is_current ? $DCprimaryColor : '#fff',
                color: plan.is_current && '#fff ',
                margin: plan.is_current ? '20px 0 30px 0' : '20px 0',
                width: '20%',
              }}
              className={plan.is_current && 'active'}
              key={i}
            >
              <PixelFlexBox
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                padding="13px 25px"
              >
                <PixelText
                  textSize="36px"
                  style={{
                    margin: '0',
                    color: plan.is_current ? '#fff' : '#231d4f',
                    fontWeight: '600',
                  }}
                >
                  {plan.plan_cost || '0'}
                </PixelText>
                <PixelText
                  textSize="17px"
                  style={{
                    marginLeft: '5px',
                    color: plan.is_current ? '#fff' : '#848199',
                  }}
                >
                  PKR
                </PixelText>
              </PixelFlexBox>
              <PixelFlexBox justifyContent="center" padding="0 10px 15px 10px">
                <PixelText
                  textSize="25px"
                  style={{
                    color: plan.is_current ? '#fff' : '#231d4f',
                  }}
                >
                  {plan.plan_name}
                </PixelText>
              </PixelFlexBox>
              <PixelFlexBox flexDirection="column" padding="0 0 4px 12px">
                {plan.details.data.map((data, i) => {
                  return (
                    <PixelFlexBox
                      justifyContent="flex-start"
                      margin="0 0 5px 0"
                      gap="5px"
                      key={i}
                    >
                      <PixelFlexBox
                        width="20px"
                        height="20px"
                        alignItems="center"
                        justifyContent="center"
                        backgroundColor="rgba(82, 67, 194, 0.103693)"
                        style={{ borderRadius: '50%' }}
                      >
                        <PlusIcon
                          style={{
                            color: plan.is_current ? '#fff' : $DCprimaryColor,
                          }}
                          size={18}
                        />
                      </PixelFlexBox>
                      <PixelDiv width="70%" padding="0 10px 0 0">
                        {data.carrier}: {data.cost}
                      </PixelDiv>
                    </PixelFlexBox>
                  )
                })}
              </PixelFlexBox>
              <PixelFlexBox
                margin="15px 0"
                alignItems="center"
                justifyContent="space-around"
              >
                <Button
                  disabled={plan.is_current}
                  className={plan.is_current && 'active'}
                  onClick={() => {
                    if (remainingCredits > 0) {
                      showFailure(
                        'You can not subscribe to a new plan until you have used all your credits in your current plan',
                      )
                      return
                    }
                    handleBuy(plan.id)
                  }}
                >
                  {plan.is_current ? 'Subscribed' : 'Subscribe'}
                </Button>
              </PixelFlexBox>
            </PixelFlexBox>
          )
        })}
      </PixelFlexBox>
    </>
  )
}

// Need to Update in pixel base
const Button = styled(DcButton)`
  &.active {
    border: 1px solid #ffffff !important;
    color: #ffffff;
    opacity: 1 !important;
    outline: none;
  }
`
export default SMSPlans
